import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant, { Lazyload } from 'vant'
import './permission' // 拦截器
import '@/styles/index.scss' // global css
import 'vant/lib/index.css'
import './assets/flexible'
import '@/styles/sypublic.scss'
import i18n from './lang' // 国际化

const defaultAvatar = require('@/assets/avatar.png')
if (process.env.NODE_ENV === 'develpment') {
  // 吐槽一波：不支持 import 方式
  const VConsole = require('vconsole')
  new VConsole()
}
Vue.use(Vant)
Vue.use(Lazyload, {
  loading: defaultAvatar,
  error: defaultAvatar
})

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
